module.exports = __webpack_public_path__ + "static/media/tomer.046ef33d.png";